import { useTheme } from "@mui/material"

function useStyles() {
    const { breakpoints } = useTheme()
    return {
        container: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            paddingTop: '30px',
            paddingBottom: '2px',
        },
        body: ({ detail }: { detail: boolean }) => ({
            padding: '0px 480px 2px 2px',
            width: '100%',
            height: '100%',
            display: 'flex',
            gap: 3,
            [breakpoints.down('xl')]: {
                padding: '0px 50px 0px 2px',
            },
            ...!detail && {
                padding: '0px 480px 0px 2px',
            },
        }),
        detail: {
            padding: 3,
            margin: '0px',
            width: '450px',
            height: '100%',
            position: 'fixed',
            right: '0px',
            overflow: 'auto',
            paddingBottom: '80px'
        }
    }
}

export { useStyles }